import {createContext} from 'react';

const ProblemSolverContext = createContext ();

export default ProblemSolverContext;
